const productsData = {
    [process.env.STRIPE_PRODUCT1_PRICE]: {price: 0.99, quantity: 20}
  }

export default productsData